import { Ref, ref, computed } from "vue";
import { BaseOptionWithoutCode } from "@/types/Option";
import { MstBukaService } from "@/service/MstBukaService";
import { Buka } from "@/types/KoyouKeiyaku";
import { BukaDetail, GetBukaReq, UpsertBukaRes } from "@/types/MstBuka";

/*
 * 初期処理
 */
export function useMstBukaInit() {
  const loading = ref(0) // APIで読み込みをする本数
  const isError = ref(false)

  // 部課一覧
  const bukaList: Ref<BukaDetail[]> = ref([]);

  const bukas: Ref<Buka[]> = ref([]);

  const serchCondition: Ref<GetBukaReq> = ref({
    mst_buka_id: null,
    buka_code: null,
    buka_name: null,
    buka_kana: null
  })

  // 部課オプション値保存用
  let bukaOptions: Ref<BaseOptionWithoutCode[]> = ref([]);
  // 全部課オプション
  let allBukaOptions: Ref<BaseOptionWithoutCode[]> = ref([]);

  const srv = new MstBukaService();

  /**
   * 全ての部課一覧を取得します
   */
  const getAllBuka = async () => {
    loading.value++
    bukas.value = await srv.getAll();
    loading.value--
  }

  /**
   * 表示用の一覧
   */
  const getBukaList = async (cond?: GetBukaReq) => {
    loading.value++
    bukaList.value = await srv.getList(cond);
    loading.value--
  }

  /**
   * 全ての部課一覧を取得します
   */
  const getAllBukaOptions = async () => {
    loading.value++
    allBukaOptions.value = await srv.getAllOptions();
    loading.value--
  }

  /**
   * 指定した所属会社の部課一覧を取得します
   * @param syozokuId 所属ID
   */
  const getBukaOptionsBySyozokuId = async (syozokuId: number) => {
    loading.value++
    bukaOptions.value = await srv.getOptionsBySyozokuId(syozokuId);
    loading.value--
  }

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  })

  return {
    isLoading,
    isError,
    bukas,
    bukaList,
    bukaOptions,
    getAllBuka,
    getBukaList,
    allBukaOptions,
    getBukaOptionsBySyozokuId,
    getAllBukaOptions,
    serchCondition
  }
}
